import React from 'react'

function HomeBox6() {
    return (
        <div className='homebox2main'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/loopy-steps.png" alt="box6-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Easy Setup</span>
                        <h2>Simple setup, fast launch</h2>
                        <ul>
                            <li>Get your loyalty program up and running in just a few clicks. Create your digital stamp card, set rewards, and upload your branding — no developers, custom apps, or extra hardware needed.</li>
                            <li>Share your card through a QR code or link, let customers save it to Apple or Google Wallet, and start rewarding instantly with the Stamper App.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox6